export class Expense {
    id: number;
    expenseDate: string;
    expenseType: string;
    supportingData: number;
    remarks: string;
    amount: number;
    orNumber: string;
    isVatable: boolean;
    createdBy: string;
    createdById: number;
    createdDate: string;
    updatedBy: string;
    updatedById: number;
    updatedDate: string;

    constructor(){
        this.id = 0;
        this.isVatable = false;
        this.amount = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/expenses/expense.ts